/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Scope_AllInputs */



/**
* | output |
* | --- |
* | "All" |
*
* @param {Explorer_Search_Scope_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_scope_all = /** @type {((inputs?: Explorer_Search_Scope_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Scope_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("All")
	if (locale === "de") return /** @type {LocalizedString} */ ("All")
	if (locale === "it") return /** @type {LocalizedString} */ ("All")
	if (locale === "ru") return /** @type {LocalizedString} */ ("All")
	if (locale === "es") return /** @type {LocalizedString} */ ("All")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("All")
	if (locale === "ja") return /** @type {LocalizedString} */ ("All")
	if (locale === "hi") return /** @type {LocalizedString} */ ("All")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("All")
	return /** @type {LocalizedString} */ ("All")
});